import React from 'react';
import { connect } from 'react-redux';

import GameGuide from './GameGuide';
import { GuideStepEnum, SideBarItems } from '../shared';
import { setActiveSidebarItem } from '../actions/sideBarActions';
import Popup from './Popup';
import LoadScreen from './Default/loadScreen';
import { setLoadingComplete } from '../actions/gameActions';

import LevelEditor from './LevelEditor';
import TestPlayer from './TestPlayer';

// ALL SCSS SHOULD COME FROM THIS FILE
import '../../../scss/base.scss';

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = { loaded: false };
    }

    onStopEdit = () => {
        const { dispatch } = this.props;
        dispatch(setActiveSidebarItem(SideBarItems.NONE));
    };

    onLoadComplete = () => {
        const { dispatch } = this.props;

        dispatch(setLoadingComplete(true));
        this.setState({ loaded: true });
    };

    render() {
        const { gameGuide, gameKit, game } = this.props;
        const { loaded } = this.state;

        return (
            <>
                <LoadScreen title="Game Studio Laden" progress={game.loadingProgress} text={game.loadingText} complete={game.loadingComplete} onComplete={this.onLoadComplete} />
                <TestPlayer active={gameKit.testing} id="gameplayer" />
                <LevelEditor active={gameGuide.currentStep === GuideStepEnum.INACTIVE && !gameKit.testing} />
                {gameGuide.currentStep !== GuideStepEnum.INACTIVE && !gameKit.testing ? <GameGuide loadedGamekit={loaded} /> : <></>}
                <Popup />
            </>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    gameGuide: state.gameGuide,
    blokEditor: state.blokEditor,
    gameKit: state.gameKit,
    game: state.game
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);
